// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"148":"f741574e","770":"f741574e","860":"f741574e"}[chunkId] + ".chunk.css";
};